export default __webpack_public_path__ + "static/media/pvilla7-1.0ec11d80.jpg";